// extracted by mini-css-extract-plugin
module.exports = {"container":"UnsupportedBlock_container__79VO_","title":"UnsupportedBlock_title__XIl6j"};